<template lang="pug">
.container-restrictions(id="ScheduleHolidayEditor-container")
  .row.section-title
    p {{ isSaving ? $t('saving...') : $t('Play period sets') }}
  .row
    .column.column-left
    .column.column-right
      el-select(
        :id="model + 'ScheduleHolidayEditor-select'",
        v-model='holidaysSelected',
        multiple,
        filterable,
        default-first-option,
        :placeholder="$t('Choose sets')",
        style="width: 555px",
        :disabled='$store.state.User.user.test && !item.test'
      )
        el-option(v-for='holiday in holidays', :key='holiday.id', :label='holiday.name', :value='holiday.id', :id="'ScheduleHolidayEditor-option' + holiday.id")
</template>

<script>
import Vue from 'vue'

export default {
  components: {
  },
  props: ['item', 'model'],
  watch: {
    holidaysSelected: async function (newVal, oldVal) {
      if (newVal.length === 0 && oldVal.length === 0) return
      this.isSaving = true
      await Vue.axios.put(`${this.model}/${this.item.id}/holidaysets/`,
        this.holidaysSelected
      )
      setTimeout(() => {
        this.isSaving = false
      }, 300)
    }
  },
  async created () {
    if (this.$store.state.Holidayset.holidayset_list.length === 0) {
      await this.$store.dispatch('Holidayset/getList')
    }
    this.holidaysSelected = this.item.HolidaySets.map(dts => dts.id)
  },
  data () {
    return {
      errors: {},
      holidays: this.$store.state.Holidayset.holidayset_list,
      holidaysSelected: [],
      isSaving: false
    }
  },
  methods: {
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-restrictions {
  display: flex;
  flex-direction: column;
  font-size: $--font-size-base;
  margin: auto;
  width: 95%;
  border-bottom: 1px $--border-style-base rgba($--border-color-extra-light, 0.2);
  padding-bottom: 10px;
  margin-bottom: 10px;
  .row {
    display: flex;
    &.section-title {
      font-size: $--font-size-big;
      font-weight: bold;
    }
    .column {
      &.column-left, &.column-right {
        width: 195px;
      }
      &.column-left {
        margin-left: 70px;
      }
      &.column-buttons {
        display: flex;
        align-items: center;
        .button {
          max-height: 30px;
          width: 95px;
        }
      }
    }
  }
}
  </style>



// WEBPACK FOOTER //
// src/components/Common/ScheduleHolidayEditor.vue